import styled from "styled-components/macro";

export const SlideIn = styled.div<SlideInProps>`
    @keyframes slideInFromLeft {
        from {
            transform: translateX(-100%);
            opacity: 0;
        }
        to {
            transform: translateX(0%);
            opacity: 1;
        }
    }
    @keyframes slideInFromRight {
        from {
            transform: translateX(100%);
            opacity: 0;
        }
        to {
            transform: translateX(0%);
            opacity: 1;
        }
    }
    animation: ${({ fromRight }) => (fromRight ? "slideInFromRight" : "slideInFromLeft")} 0.7s
        cubic-bezier(0.18, 0.93, 0.37, 1);

    width: 100%;
`;

interface SlideInProps {
    fromRight?: boolean;
}

export default SlideIn;
